import { createSelector } from 'reselect';
import { selectAccountState } from '../accountSelectors';
export const selectVideosState = createSelector(selectAccountState, account => account.videos);
export const selectVideos = createSelector(selectVideosState, (videos) => videos.list);
